import type { ParsedPieChart, PieSlice } from './piechart-types';

const MERMAID_LINE_SEPARATOR = '\n';
const PIE_HEADER_REGEX = /^pie\b/i;
const PIE_TITLE_REGEX = /^pie\s+(?:showData\s+)?title\s+(.+)$/i;
const PIE_TITLE_FALLBACK_REGEX = /^pie\s+title\s+(.+)$/i;
const PIE_SLICE_REGEX = /^"([^"]+)"\s*:\s*([\d.]+)$/;

function getMermaidLines(raw: string): string[] {
  return raw
    .split(MERMAID_LINE_SEPARATOR)
    .map((line) => line.trim())
    .filter((line) => line.length > 0);
}

function parsePieTitle(pieLine: string): string | null {
  const titleMatch = pieLine.match(PIE_TITLE_REGEX)
    ?? pieLine.match(PIE_TITLE_FALLBACK_REGEX);

  return titleMatch?.[1]?.trim() ?? null;
}

function parseSliceLine(line: string): PieSlice | null {
  const match = line.match(PIE_SLICE_REGEX);
  if (!match) {
    return null;
  }

  return {
    label: match[1],
    value: parseFloat(match[2]),
  };
}

function parsePieSlices(lines: string[]): PieSlice[] {
  return lines
    .reduce<PieSlice[]>((parsedSlices, line) => {
      const slice = parseSliceLine(line);
      return slice ? [...parsedSlices, slice] : parsedSlices;
    }, []);
}

export function parseMermaidPie(raw: string): ParsedPieChart | null {
  const lines = getMermaidLines(raw);
  const pieIndex = lines.findIndex((line) => PIE_HEADER_REGEX.test(line));
  if (pieIndex === -1) return null;

  const slices = parsePieSlices(lines.slice(pieIndex + 1));

  if (slices.length === 0) return null;

  return {
    title: parsePieTitle(lines[pieIndex]),
    slices,
  };
}
